import styled from 'styled-components/macro'

import { Layout, Text } from '@loadsmart/loadsmart-ui'

import { Icon } from 'core/ui/components/icon/Icon'

import {
  formatRelativeSpotQuoteDeadline,
  formatSpotQuoteDeadline,
  getDeadlineText,
} from '../presenter/spotQuotePresenter'

const StyledText = styled(Text)`
  text-align: left;
`

export type SpotQuoteBidDeadlineProps = {
  deadline?: Date
  isExpired: boolean
  isMultiline?: boolean
  isBulkQuote?: boolean
}

export function SpotQuoteBidDeadline({
  deadline,
  isExpired,
  isMultiline,
  isBulkQuote,
}: SpotQuoteBidDeadlineProps) {
  const { deadlineTimeText, sendRatesText } = getDeadlineText({ isExpired, isBulkQuote })

  if (!deadline) return <StyledText color="color-danger-dark">Expired</StyledText>

  if (isExpired) {
    return (
      <Layout.Group align="center" space="s">
        <Icon name="clock" size="16" />
        <StyledText color="color-danger-dark">
          {deadlineTimeText}
          <strong>{formatSpotQuoteDeadline(deadline)}</strong>. <>{isMultiline && <br />}</>
          {sendRatesText}
        </StyledText>
      </Layout.Group>
    )
  }

  return (
    <Layout.Group align="center" space="s">
      <Icon name="clock" size="16" />
      <StyledText>
        {deadlineTimeText}
        {isMultiline && (
          <>
            :<br />
          </>
        )}

        <StyledText variant="body-bold">
          {` ${formatRelativeSpotQuoteDeadline(undefined, deadline)}`}
        </StyledText>
      </StyledText>
    </Layout.Group>
  )
}
